<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="user"
                                label="Select a faculty"
                                :rules="[formRules.required]"
                                @update:model-value="initFacultyLoad"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="facultyData"
                                :item-title="getItemTitle"
                                item-value="id"
                                return-object
                                :readonly="action == 'edit' && user?.length != 0"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col v-if="user != null && user?.length != 0" class="text-right" cols="12" md="8">
                            <v-btn
                            v-if="areAllApproved(data) != true"
                            @click="showAddFacultyLoadDialog()"
                            prepend-icon="mdi-plus"
                            class="mt-1 rounded-lg"
                            color="routesColor"
                            height="40px"
                            elevation="2">
                                Add Course Load
                            </v-btn>
                        </v-col>
                        <v-col cols="12" class="mt-n3">
                            <v-card v-if="user == null || user?.length == 0" elevation="3">
                                <v-card-text>
                                    Please select a faculty
                                </v-card-text>
                            </v-card>
                            <v-card v-else class="dt-container">    
                                <v-data-table
                                    :mobile="isMobileOrTablet()"
                                    :headers="headers"
                                    :items="data"
                                    :loading="loading"
                                    :items-per-page="15"
                                    :items-per-page-options="[15,30, 50, 100, -1]"
                                >
                                <template v-slot:loading>
                                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                </template>
                                <template v-slot:item.title="{ item }">
                                    <div class="text-truncate" style="max-width: 150px;">
                                        {{ item.title }}
                                    </div>
                                </template>
                                <template v-slot:item.is_approved="{ item }">
                                    <v-chip v-if="item.is_approved == true" size="small" color="green" variant="elevated">
                                        Yes
                                    </v-chip>
                                    <v-chip v-else size="small" color="gray">
                                        No
                                    </v-chip>
                                </template>
                                <template v-slot:item.datecreated="{ item }">
                                    <span>{{ formatDateTime(item.datecreated)}} </span>
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                    <div  class="d-flex justify-end ga-2">
                                        <v-btn v-if="item.is_approved == false" @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                        <v-btn v-if="item.is_approved == false"  @click="showDeleteDialog(item)" size="small" variant="outlined" text="Remove" color="red" elevation="3"></v-btn>
                                        <v-btn v-if="item.is_approved == true" @click="showViewDialog(item)" size="small" variant="outlined" text="View" color="green" elevation="3"></v-btn>
                                    </div>
                                </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Close" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDelete" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want remove this course?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDelete = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteCourse()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <FacultyLoadDialog ref="FacultyLoadDialog" @refresh="initFacultyLoad()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import FacultyLoadDialog from './Sub-Dialogs/FacultyLoadDialog.vue';

export default defineComponent({
    emits: ["refresh"],
    components: {
        FacultyLoadDialog
    },
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,
            data: [],

            headers: [
                { title: 'Course Code', align: 'start', sortable: true, key: 'code' },
                { title: 'Course Title', align: 'start', sortable: true, key: 'title' },
                { title: 'Section Code', align: 'start', sortable: true, key: 'section_code' },
                { title: 'Time', align: 'start', sortable: true, key: 'time' },
                { title: 'Day', align: 'start', sortable: true, key: 'day' },
                { title: 'Is Approved', align: 'start', sortable: true, key: 'is_approved'},
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            facultyData: [],
            user: [],
            program_id: null,

            confirmDelete: false,
            itemToDelete: null,
        }
    },
    methods: {
        initAdd(program_id){
            this.dialog = true
            this.dialog_title = 'Faculty Course Load'
            this.dialog_sub_title = 'Add faculty course load'
            this.action = 'add'

            this.initFaculty(program_id)
            this.program_id = program_id
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Faculty Course Load'
            this.dialog_sub_title = 'Edit faculty course load'
            this.action = 'edit'

            this.user = data
            this.initFacultyLoad()
        },
        initFaculty(program_id){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findFacultyWithoutLoadByProgram/' + program_id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.facultyData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        initFacultyLoad(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllBySemesterAndSchoolyear/' + this.user?.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        areAllApproved(items) {
            if(items.length == 0){
                return false
            }
            else{
                return items.every(item => item.is_approved === true);
            }
        },
        getItemTitle(item) {
            return `${item.fname} ${item.mname ? item.mname[0] + '.' :''} ${item.lname}${item.suffix ? ', ' + item.suffix : ''}` ;
        },
        showAddFacultyLoadDialog(){
            this.$refs.FacultyLoadDialog.initDirectorAdd(this.user.id, this.program_id)
        },
        showEditDialog(data){
            this.$refs.FacultyLoadDialog.initUpdate(data)
        },
        showViewDialog(data){
            this.$refs.FacultyLoadDialog.initView(data)
        },
        showDeleteDialog(data){
            this.itemToDelete = data
            this.confirmDelete = true
        },
        closeDialog(){
            this.user = []
            this.$emit('refresh')
            this.dialog = false
        },
    }
})
</script>

<style scoped>

</style>